import {
    FETCH_CITIES_BY_PROVINCES_ID_SUCCESS,
    FETCH_COUNTRIES_BY_ID_SUCCESS,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS,
    FETCH_PROVINCES_BY_ID_SUCCESS,
    FETCH_CITIES_BY_ID_SUCCESS,

    LOCATION_REQUEST_LOADING,
    LOCATION_REQUEST_ERRORS,
    CLEAR_ALL_LOCATIONS
} from "api/menu/master-files/locations/actions";

const initialState = {
    loading: false,
    errors: [],

    countries: [],
    provinces: [],
    cities: [],

    currentCountry: {},
    currentProvince: {},
    currentCity: {},
};

export default function(state = initialState, action) {
    switch (action.type) {
        case LOCATION_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case LOCATION_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_COUNTRIES_SUCCESS:
            return {
                ...state,
                countries: action.payload,
                loading: false,
                errors: [],
            };
        case FETCH_COUNTRIES_BY_ID_SUCCESS:
            return {
                ...state,
                currentCountry: action.payload,
                loading: false,
                errors: [],
            };
        case FETCH_PROVINCES_BY_COUNTRIES_ID_SUCCESS:
            return {
                ...state,
                provinces: action.payload,
                loading: false,
                errors: [],
            };
        case FETCH_PROVINCES_BY_ID_SUCCESS:
            return {
                ...state,
                currentProvince: action.payload,
                loading: false,
                errors: [],
            };
        case FETCH_CITIES_BY_PROVINCES_ID_SUCCESS:
            return {
                ...state,
                cities: action.payload,
                loading: false,
                errors: [],
            };
        case FETCH_CITIES_BY_ID_SUCCESS:
            return {
                ...state,
                currentCity: action.payload,
                loading: false,
                errors: [],
            };
        case CLEAR_ALL_LOCATIONS:
            return {
                loading: false,
                errors: [],

                countries: [],
                provinces: [],
                cities: [],

                currentCountry: {},
                currentProvince: {},
                currentCity: {},
            };
        default:
            return state;
    }
}
